import { Divider, Stack, Text, LegacyText } from "flicket-ui";

export const SignupEmbedError = () => {
  return (
    <Stack direction={"vertical"}>
      <Text variant="header.M" as="h2" px={4} py={3}>
        Form unavailable
      </Text>
      <Divider />
      <Text p={4} variant="regular">
        Sorry, this form is no longer available. If you have any questions or
        need assistance, please contact us directly.
      </Text>
    </Stack>
  );
};
